import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SberOprosResult } from 'Modules/SberOpros'

export namespace SberOprosNs {
	export type setFeedback = PayloadAction<{ result: SberOprosResult; id: string }>
}

export const sberOprosSlice = createSlice({
	name: 'sberOpros',
	initialState: {},
	reducers: {
		setFeedback: (state, action: SberOprosNs.setFeedback) => {},
	},
})
